module.exports = __webpack_public_path__ + "static/media/lungcancer.da62866b.jpg";